<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <StatusBar :params="this.$route.query.params" />

    <!-- 查詢列 -->
    <SearchBar
      :show="showSearchBar"
      @showSearchBar="showSearchBar = !showSearchBar"
      @search="(currentPage = 1), getInterviewing()"
    >
      <template v-slot:searchItem>
        <el-input
          class="w-100 item-bottom"
          clearable
          placeholder="關鍵字（姓名、Email、聯絡電話）"
          v-model.trim="searchCondition.Keyword"
        />

        <el-date-picker
          class="w-100 item-bottom"
          type="daterange"
          clearable
          :picker-options="{
            disabledDate: $common.disabledDateBeforeToday,
          }"
          range-separator="-"
          start-placeholder="面談日期(起)"
          end-placeholder="面談日期(迄)"
          v-model="searchCondition.InterviewDateRange"
        />

        <el-select
          class="w-100 item-bottom"
          filterable
          clearable
          placeholder="單位面試主管"
          v-model="searchCondition.InterviewSupervisor"
        >
          <el-option
            v-for="supervisor in supervisorOptions"
            :key="supervisor.Guid"
            :label="supervisor.Name"
            :value="supervisor.Name"
          >
          </el-option>
        </el-select>

        <el-select
          class="w-100 item-bottom"
          filterable
          clearable
          placeholder="HR 面試人員"
          v-model="searchCondition.InterviewHR"
        >
          <el-option
            v-for="supervisor in supervisorOptions"
            :key="supervisor.Guid"
            :label="supervisor.Name"
            :value="supervisor.Name"
          >
          </el-option>
        </el-select>

        <el-select
          class="w-100 item-bottom"
          clearable
          placeholder="是否已輸入成績"
          v-model="searchCondition.isWriteScore"
        >
          <el-option label="是" :value="true" />
          <el-option label="否" :value="false" />
        </el-select>
      </template>
    </SearchBar>

    <!-- 卡片顯示樣式 -->
    <div class="tool-list" v-if="personList.length > 0">
      <span class="mr-2">共計：{{ totalPerson }}人</span>
      <CardStyle @changeStyle="changeStyle" />
    </div>

    <!-- 人員卡片 -->
    <div
      class="person-card-list"
      :class="{
        'list-style': gridStyle == 'list',
        'block-style': gridStyle == 'block',
      }"
    >
      <div
        v-for="(person, index) in personList"
        :key="index"
        class="person-card infinite-list-item"
      >
        <PersonCard
          ref="personCard"
          :showCheckbox="true"
          :person="person"
          @updatePersonList="updatePersonList"
        >
          <template v-slot:note="{ props }">
            <button type="button" @click="clickResumeNote(props)">
              <eva-icon name="color-picker-outline" fill="#000" />
            </button>
          </template>
          <template v-slot:tag="{ props }">
            <div class="result">{{ props.ApprovalResult }}</div>
          </template>
          <!-- 內容 -->
          <template v-slot:middleContent="{ props }">
            <table>
              <tr>
                <th>應徵職務</th>
                <td>{{ props.Position }}</td>
              </tr>
              <tr>
                <th>面談時間</th>
                <td>{{ $common.dateTimeFormatter(props.InterviewDate) }}</td>
              </tr>
              <tr>
                <th>面談地點</th>
                <td>{{ props.InterviewPlace }}</td>
              </tr>
              <tr>
                <th>單位面試主管</th>
                <td>{{ props.InterviewSupervisor[0] }}</td>
              </tr>
              <tr>
                <th>HR 面試人員</th>
                <td>{{ props.InterviewHR[0] }}</td>
              </tr>
            </table>
          </template>
          <!-- button group -->
          <template v-slot:buttonGroup="{ props }">
            <el-dropdown>
              <button type="button" class="el-dropdown-link">
                檢視資訊<i class="el-icon-arrow-down el-icon--right"></i>
              </button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="showDetailModal(props)">
                  檢視履歷
                </el-dropdown-item>
                <el-dropdown-item @click.native="showProgressRecord(props)">
                  檢視歷程
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <button type="button" @click="clickReinvite(props)">
              重新邀約
            </button>
            <button
              type="button"
              @click="openCommonModal({ event: 'singleScore', data: props })"
            >
              輸入成績
            </button>
            <button
              type="button"
              @click="openCommonModal({ event: 'reason', data: props })"
            >
              面談未到
            </button>
          </template>
        </PersonCard>
      </div>
    </div>

    <!-- 分頁 -->
    <el-pagination
      v-if="personList.length > 0"
      background
      layout="prev, pager, next"
      :total="totalPerson"
      :page-size="9"
      @current-change="changePage"
    >
    </el-pagination>

    <!-- 功能列 -->
    <ActionBar
      :show="showActionBar"
      :totalPerson="totalPerson"
      :selectedCardList="choosePersonList"
      @showActionBar="showActionBar = !showActionBar"
      @selectAllCards="selectAllCards"
      @clearSelectCard="clearSelectCard"
    >
      <template v-slot:button>
        <button
          type="button"
          class="action-btn"
          @click="openCommonModal({ event: 'batchScore' })"
        >
          <eva-icon name="color-picker-outline" fill="#FFF" />
          <span>批次輸入成績</span>
        </button>
      </template>
    </ActionBar>

    <!-- 重新邀約 -->
    <ReinviteMailModal :personData="personData" @updatePerson="updatePerson" />

    <!-- 單次輸入成績、批次輸入成績、面談未到 Modal -->
    <div
      class="modal fade"
      id="commonModal"
      data-focus="false"
      data-backdrop="static"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        :class="modalEvent === 'reason' ? null : 'modal-xl'"
      >
        <ValidationObserver
          ref="commonModal"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form @reset.prevent="reset">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  {{ modalTitle }}
                </h5>
              </div>
              <div class="modal-body">
                <!-- 單次輸入成績、批次輸入成績 -->
                <template
                  v-if="
                    modalEvent === 'singleScore' || modalEvent === 'batchScore'
                  "
                >
                  <el-table :data="candidateScores" border style="width: 100%">
                    <el-table-column
                      fixed
                      prop="Name"
                      label="姓名"
                      min-width="20%"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.Name }}/{{
                          scope.row.IsForeigner ? "外籍" : "本籍"
                        }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      v-for="score in scoreType[0]"
                      :key="score.Seq"
                      :label="score.Name"
                      align="center"
                      min-width="40%"
                    >
                      <template slot-scope="scope">
                        <span v-for="item in scope.row.Scores" :key="item.Seq">
                          <input
                            type="number"
                            v-if="
                              item.HasOriginScore && item.Name === score.Name
                            "
                            class="form-control text-center"
                            style="background-color: #dedede"
                            disabled
                            v-model="item.OriginScore"
                          />
                          <template v-if="item.Name === score.Name">
                            <ValidationProvider
                              class="w-100"
                              :name="scope.row.Name + score.Name"
                              :rules="{
                                min_value: item.ScoreLowest,
                                max_value: item.ScoreHighest,
                              }"
                              v-slot="{ errors }"
                            >
                              <input
                                type="text"
                                class="form-control text-center"
                                :style="{
                                  backgroundColor: !item.CanWrite
                                    ? '#dedede'
                                    : '#ffffff',
                                }"
                                :disabled="!item.CanWrite"
                                v-model="item.Score"
                              />
                              <span v-if="errors[0]" class="text-danger">
                                {{ errors[0] }}
                              </span>
                            </ValidationProvider>
                          </template>
                        </span>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
                <!-- 面談未到 -->
                <template v-else>
                  <div class="form-group">
                    <ValidationProvider
                      name="原因"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <textarea
                        type="text"
                        rows="5"
                        class="form-control"
                        placeholder="請輸入原因"
                        v-model.trim="declineInterview.reason"
                      />
                      <span v-if="errors[0]" class="text-danger">
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>
                  </div>
                </template>
              </div>
              <div class="modal-footer">
                <button
                  type="reset"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  {{ i18n("Buttons.Cancel") }}
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="handleSubmit(saveCommonModal)"
                >
                  {{ i18n("Buttons.Save") }}
                </button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- 履歷 Note -->
    <ResumeNoteModal :personData="interviewee" />

    <!-- 檢視資訊 -->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInLeft"
      leave-active-class="animated bounceOutRight"
    >
      <div class="detail-modal" v-if="isShowDetail">
        <div class="detail-modal-inner">
          <div class="menu">
            <a @click.prevent="detailCurrentPage = 0">
              <span>
                <eva-icon name="person-outline" fill="#FFF" />
                履歷
              </span>
            </a>
            <div
              class="close-show-detail"
              @click="isShowDetail = !isShowDetail"
            >
              <eva-icon
                name="close-circle"
                fill="#FFF"
                width="50"
                height="50"
              />
            </div>
          </div>
          <div class="page-wrap">
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 0" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">履歷</div>
                    <div class="item text-right">
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="$common.downloadResumePDF(ResumeType, ResumeId)"
                      >
                        下載 PDF
                      </button>
                    </div>
                  </div>
                  <IdlResume
                    v-if="ResumeType === 'IDL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                  <DlResume
                    v-if="ResumeType === 'DL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                </section>
              </perfect-scrollbar>
            </transition>
          </div>
        </div>
      </div>
    </transition>
    <!-- 檢視歷程 -->
    <ProgressRecordModal :Name="Name" :UserId="UserId" :Email="Email" />
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
// 招募狀態列表
import StatusBar from "@/components/back/OpeningManage/StatusBar";
// 公司LOGO
import Logo from "@/components/company/Logo.vue";
// 卡片樣式
import CardStyle from "@/components/back/Card/CardStyle";
// 人員卡片
import PersonCard from "@/components/back/Card/Person";
// 功能列
import ActionBar from "@/components/back/ToolBar/ActionBar";
// 查詢列
import SearchBar from "@/components/back/ToolBar/SearchBar";
// 重新邀約
import ReinviteMailModal from "@/components/back/Modal/ReinviteMail";
// 履歷 Note
import ResumeNoteModal from "@/components/back/Modal/ResumeNote";
// 履歷(DL/IDL)
import IdlResume from "@/components/customize/Back/IdlResume";
import DlResume from "@/components/customize/Back/DlResume";
// 歷程
import ProgressRecordModal from "@/views/back/TalentQuery/ResultPage/Modal/ProgressRecord";

export default {
  name: "Interviewing",

  props: {
    did: { // 需求單號
      type: String,
    }
  },

  components: {
    StatusBar,
    Logo,
    PersonCard,
    CardStyle,
    ActionBar,
    SearchBar,
    ReinviteMailModal,
    ResumeNoteModal,
    IdlResume,
    DlResume,
    ProgressRecordModal,
  },

  data() {
    return {
      // 卡片樣式 (有 block / list 兩種)
      gridStyle: "block",

      // modal 事件 (單次輸入成績、批次輸入成績、面談未到)
      modalEvent: "",
      modalTitle: "",

      // data
      personList: [],
      interviewee: {},

      // 檢視資訊
      MatchId: null,
      ResumeId: null,
      isShowDetail: false, // 預設不顯示
      detailCurrentPage: 0, // 點擊選項
      ResumeType: null, // 履歷種類

      // 重新邀約
      personData: {},

      // 面談未到
      declineInterview: {},

      // 功能列
      showActionBar: false, // 預設不顯示
      choosePersonList: [], // 選取之人員列表

      // 查詢列
      showSearchBar: false,
      searchCondition: {},

      supervisorOptions: [],

      // 單次輸入成績、批次輸入成績
      scoreType: [], // 成績類型
      candidateScores: [], // 應聘者成績

      // 檢視歷程
      Name: null,
      UserId: null,
      Email: null,

      // 分頁
      totalPerson: 0, // 共幾筆
      currentPage: 1, // 當前第幾頁
    };
  },

  methods: {
    // 取得 待面談
    getInterviewing() {
      this.updateLoading(true);
      this.$store.commit("ScrollTop", true);

      this.$api.jobManagement
        .getInInterviewingPaging(
          {
            ...this.searchCondition,
            interviewDateStart: this.searchCondition.InterviewDateRange
              ? this.$common.dateFormatter(
                  this.searchCondition.InterviewDateRange[0]
                )
              : null,
            interviewDateEnd: this.searchCondition.InterviewDateRange
              ? this.$common.dateFormatter(
                  this.searchCondition.InterviewDateRange[1]
                )
              : null,
            Page: this.currentPage,
            PerPage: 9,
          },
          this.did
        )
        .then((response) => {
          if (response.status === 200) {
            if (response.data.Quantity > 0) {
              this.totalPerson = response.data.Quantity;
              this.personList = response.data.Datas;
              this.$store.commit("ScrollTop", false);
            }
          }
          this.updateLoading(false);
        });
    },

    // 換頁
    changePage(page) {
      this.currentPage = page;
      this.getInterviewing();
    },

    // 重新邀約
    clickReinvite(person) {
      this.personData = person;
      this.$store.commit("OpenReinviteMailModal", true);
    },

    // 履歷 Note
    clickResumeNote(person) {
      this.interviewee = person;
      this.$store.dispatch("getResumeSummary", person.MatchId);
      this.$store.commit("OpenResumeNoteModal", true);
    },

    // 更新卡片
    updatePerson() {
      this.currentPage = 1;
      this.getInterviewing();
    },

    // 開啟 common modal
    async openCommonModal({ event, data }) {
      this.updateLoading(true);
      if (event === "singleScore" || event === "batchScore") {
        // 單次輸入成績、批次輸入成績
        this.modalEvent = event;
        this.modalTitle = "輸入成績";
        let person = await this.$api.interview.getScores({
          ManpowerDemandNo: this.did,
          MatchIds:
            event === "singleScore"
              ? [data.MatchId]
              : this.choosePersonList.map((item) => item.MatchId),
        });
        this.scoreType = person.data.map((item) => item.Scores);
        this.candidateScores = person.data;
      } else {
        // 面談未到
        this.modalEvent = "reason";
        this.modalTitle = "面談未到";
        this.declineInterview = {
          matchId: data.MatchId,
          reason: "",
        };
      }
      this.$refs.commonModal.reset();
      this.updateLoading(false);
      $("#commonModal").modal("show");
    },

    // 儲存 common modal
    saveCommonModal() {
      $("#commonModal").modal("hide");
      this.updateLoading(true);
      if (
        this.modalEvent === "singleScore" ||
        this.modalEvent === "batchScore"
      ) {
        // 單次輸入成績、批次輸入成績
        this.$api.interview
          .putScores({
            ManpowerDemandNo: this.did,
            UpdateUserName: this.$cookies.get("userName"),
            Candidates: this.candidateScores.map((item) => {
              return {
                ...item,
                Scores: item.Scores.map((score) => {
                  return {
                    ...score,
                    Score: score.Score === null ? null : Number(score.Score),
                  };
                }),
              };
            }),
          })
          .then((response) => {
            if (response.status === 200) {
              this.$notify({
                title: "成功",
                message: "儲存成功",
                type: "success",
                duration: 2000,
              });
              this.clearSelectCard();
            }
            this.updateLoading(false);
          });
      } else {
        // 面談未到
        const data = {
          matchId: this.declineInterview.matchId,
          reason: this.declineInterview.reason,
        };
        this.$api.jobManagement.interviewNotArrived(data).then((response) => {
          if (response.status === 200) {
            this.personList.forEach((item, index, arr) => {
              if (item.MatchId === data.matchId) {
                arr.splice(index, 1);
              }
            });
            this.$notify({
              title: "成功",
              message: "儲存成功",
              type: "success",
              duration: 2000,
            });
            this.$store.dispatch("GetJobManagementCount");
          }
          this.updateLoading(false);
        });
      }
    },

    // 檢視資訊 Modal
    showDetailModal(person) {
      this.MatchId = person.MatchId;
      this.ResumeId = person.ResumeId;
      this.ResumeType = person.ResumeType;
      this.isShowDetail = true;
    },

    // 檢視歷程
    showProgressRecord(person) {
      this.MatchId = person.Id;
      this.Name = person.Name;
      this.UserId = person.UserId;
      this.Email = person.Email;
      this.$store.commit("OpenCandidateProcessModal", true);
    },

    // 即時更新選取人員之列表
    updatePersonList(choosePerson) {
      let repeatIndex = this.choosePersonList.findIndex(
        (element) => element.MatchId === choosePerson[0].MatchId
      );
      if (repeatIndex === -1) {
        this.choosePersonList.push(choosePerson[0]);
      } else {
        this.choosePersonList.splice(repeatIndex, 1);
      }
    },

    // 全選人員卡片
    selectAllCards() {
      this.personList.forEach((item) => {
        if (!item.isChecked) {
          item.isChecked = true;
        }
      });
      this.choosePersonList = this.personList.filter(
        (item) => item.isChecked === true
      );
    },

    // 清除全選
    clearSelectCard() {
      this.personList.forEach((item) => {
        item.isChecked = false;
      });
      this.choosePersonList = [];
    },

    async getData() {
      try {
        await this.getInterviewing();
        // 取得 主管列表
        const backgroundUser =
          await this.$api.backgroundUser.getBackgroundUser();
        this.supervisorOptions = backgroundUser.data.map((user) => {
          return {
            Guid: user.UserId,
            Name: user.Name,
          };
        });
      } catch (error) {
        this.$notify({
          title: error.name,
          message: error.message + "請聯繫系統管理員",
          type: "error",
          duration: 0,
        });
      }
    },

    // 卡片樣式
    changeStyle(style) {
      this.gridStyle = style;
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  watch: {
    // 選取人員列表
    choosePersonList: function (e) {
      if (e.length > 0) {
        this.showActionBar = true;
        this.showSearchBar = false;
      } else {
        this.showActionBar = false;
      }
    },
    // 檢視資訊
    isShowDetail: function (e) {
      if (!e) {
        this.detailCurrentPage = 0;
      }
    },
  },

  async created() {
    this.getData();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-input {
  display: block;
}

/deep/ .el-select {
  display: block;
}
</style>
